import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import { Row, Col } from 'react-bootstrap'

import logoGreenpay from './../assets/images/gpLogo.png'

const LOGO_MAX_WIDTH_PX = 200

export const LogoComponent = (props) => {
    const { width = LOGO_MAX_WIDTH_PX, logo, alwaysGrenpayLogo = false } = props
    const [imgSrc, setImgSrc] = useState(logoGreenpay)

    useEffect(() => {
        if (alwaysGrenpayLogo) {
            setImgSrc(logoGreenpay)
            return
        }
        const next =
            logo && String(logo).trim() ? String(logo).trim() : logoGreenpay
        setImgSrc(next)
    }, [logo, alwaysGrenpayLogo])

    return (
        <Row>
            <Col className="d-flex justify-content-center">
                <img
                    src={imgSrc}
                    alt="Logo"
                    onError={() => setImgSrc(logoGreenpay)}
                    style={{
                        maxWidth: Math.min(width, LOGO_MAX_WIDTH_PX),
                        width: 'auto',
                        height: 'auto',
                        objectFit: 'contain',
                        display: 'block'
                    }}
                />
            </Col>
        </Row>
    )
}

LogoComponent.propTypes = {
    width: PropTypes.number,
    logo: PropTypes.string,
    alwaysGrenpayLogo: PropTypes.bool
}
